module.exports = __webpack_public_path__ + "771276c49bec8fc84c7d7348fcceea97.jpg";